import keyboards from "./keyboards"

const number = "number keyboards"
const text = "text keyboards"
const personalInfo = "specialty keyboards"

export const categories = [number, text, personalInfo]

export default {
  text: {
    description: "Standard input keyboard for the user's current locale.",
    keyboard: keyboards.inputmode.text,
    category: [text],
  },
  search: {
    keyboard: keyboards.inputmode.search,
    description: "A virtual keyboard optimized for search input.",
    category: [text],
  },
  tel: {
    keyboard: keyboards.inputmode.tel,
    description:
      "A telephone keypad input, including the digits 0–9, the asterisk (*), and the pound (#) key.",
    category: [personalInfo],
  },
  url: {
    keyboard: keyboards.inputmode.url,

    description:
      "A keypad optimized for entering URLs. This may have the / key more prominent, for example.",
  },
  email: {
    keyboard: keyboards.inputmode.email,
    description:
      "A virtual keyboard optimized for entering email addresses. Typically includes the @ character as well as other optimizations.",
    category: [personalInfo],
  },
  numeric: {
    keyboard: keyboards.inputmode.numeric,
    description:
      "Numeric input keyboard, but only requires the digits 0–9. Devices may or may not show a minus key.",
    category: [number],
  },
  decimal: {
    description:
      "Numeric input keyboard containing the digits and decimal separator for the user's locale (typically . or ,).",
    keyboard: keyboards.inputmode.decimal,
    category: [number],
  },

  none: {
    description:
      "No virtual keyboard. For when the page implements its own keyboard input control.",
  },
}
